import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import FEDetailsAccordion from '../../../components/DetailsAccordion/FEDetailsAccordion';
import ZoomControlButton from '../../../components/ZoomControlButton';
import { ViewSwitch } from '../../../components/CardViews/CardViews';
import { updateChartType, saveConfig } from '../../../components/Filter/FilterActions';
import { getDetailsData } from '../FlowEfficiencyActions';
import chartColumnsIcon from '../../../assets/img/chart-columns.svg';
import chartScatterplotIcon from '../../../assets/img/chart-scatterplot.svg';

import FlowEfficiencyChart from './FlowEfficiencyChart';
import AvgFE from './AvgFE';

import '../FlowEfficiency.scss';

class WallboardFlowEfficiencyChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chartType !== this.props.chartType) {
      this.props.getDetailsData(this.props.dates);
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  handleChartTypeChange = type => {
    if (type === this.props.chartType) return;
    this.props.updateChartType(type);
    this.props.saveConfig();
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Flow Efficiency Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="fe" showAvgChart options={{ avgChartTooltip: 'Average flow efficiency' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.avgChart && (this.props.data.series && !!this.props.data.series.length ? (
            <AvgFE data={this.props.data.series} dateFormat={this.props.dateFormat} />
          ) : (
            <CardPlaceholder title="Average flow efficiency" shape="line" loading={this.props.isLoading} />
          ))}
        </div>
        <div className="chart_row">
          <div className="diagram_details">
            <ViewSwitch
              views={[{ id: 'column', icon: chartColumnsIcon }, { id: 'scatterplot', icon: chartScatterplotIcon }]}
              active={this.props.chartType}
              onChange={this.handleChartTypeChange}
            />
            <ZoomControlButton chart="fe" />
            <FlowEfficiencyChart id="FlowEfficiency" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
          </div>
          <FEDetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDetailsData: dates => dispatch(getDetailsData(dates)),
    updateChartType: type => dispatch(updateChartType(type)),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.fe.avgChart,
    data: state.fe.data,
    dates: state.filters.dates,
    chartType: state.filters.fe.chartType,
    isLoading: state.fe.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WallboardFlowEfficiencyChart);
